<template>
  <b-container fluid>
    <b-row align-h="center" v-if="!loaded">
      <h4>Loading...</h4>
    </b-row>
    <b-row align-h="center" v-if="loaded">
      <h4>Totals by Country</h4>
    </b-row>
    <b-row>
      <b-col>
        <chart-school-count
          v-if="loaded"
          :chartData="schoolChartData"
          :styles="countStyles"
          class="m-2"
        ></chart-school-count>
      </b-col>
      <b-col>
        <chart-teacher-count
          v-if="loaded"
          :chartData="teacherChartData"
          :styles="countStyles"
          class="m-2"
        ></chart-teacher-count>
      </b-col>
      <b-col>
        <chart-student-count
          v-if="loaded"
          :chartData="studentChartData"
          :styles="countStyles"
          class="m-2"
        ></chart-student-count>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="m-4" v-if="loaded">
          <h4>Namibia Trainers' Activity</h4>
          <chart-namibia-trainers-activity
            v-if="loaded"
            :chartData="namibiaActivityData"
            :styles="activityStyles"
          ></chart-namibia-trainers-activity>
        </div>
      </b-col>
      <b-col>
        <div class="m-4" v-if="loaded">
          <h4>Malawi Trainers' Activity</h4>
          <chart-malawi-trainers-activity
            v-if="loaded"
            :chartData="malawiActivityData"
            :styles="activityStyles"
          ></chart-malawi-trainers-activity>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DashboardService from "@/services/DashboardService";
import MIOSerivce from "@/services/MIOService";
import ChartStudentCount from "@/charts/ChartStudentCount";
import ChartTeacherCount from "@/charts/ChartTeacherCount";
import ChartSchoolCount from "@/charts/ChartSchoolCount";
import ChartMalawiTrainersActivity from "@/charts/ChartMalawiTrainersActivity";
import ChartNamibiaTrainersActivity from "@/charts/ChartNamibiaTrainersActivity";

export default {
  name: "HeadlineData",
  components: {
    ChartStudentCount,
    ChartTeacherCount,
    ChartSchoolCount,
    ChartMalawiTrainersActivity,
    ChartNamibiaTrainersActivity
  },
  data() {
    return {
      loaded: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    ...mapActions({
      GET_STUDENT_COUNT: "dashboards/GET_STUDENT_COUNT",
      GET_TEACHER_COUNT: "dashboards/GET_TEACHER_COUNT",
      GET_SCHOOL_COUNT: "dashboards/GET_SCHOOL_COUNT",
      GET_MALAWI_ACTIVITY: "dashboards/GET_MALAWI_TRAINERS_ACTIVITY",
      GET_NAMIBIA_ACTIVITY: "dashboards/GET_NAMIBIA_TRAINERS_ACTIVITY",
      GET_VISIT_COUNT: "mio/GET_VISIT_COUNT",
      GET_GROUP_COUNT_1: "mio/GET_GROUP_COUNT_1"
    }),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    async getCountData() {
      this.loaded = false;
      try {
        const studentCount = await this.GET_STUDENT_COUNT();
        const teacherCount = await this.GET_TEACHER_COUNT();
        const schoolCount = await this.GET_SCHOOL_COUNT();
        const malawiActivity = await this.GET_MALAWI_ACTIVITY();
        const namibiaActivity = await this.GET_NAMIBIA_ACTIVITY();
        const visitData = await this.GET_VISIT_COUNT("Module");
        const groupData = await this.GET_GROUP_COUNT_1();
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    studentChartData: {
      get() {
        return this.$store.state.dashboards.studentCount;
      }
    },
    teacherChartData: {
      get() {
        return this.$store.state.dashboards.teacherCount;
      }
    },
    schoolChartData: {
      get() {
        return this.$store.state.dashboards.schoolCount;
      }
    },
    malawiActivityData: {
      get() {
        return this.$store.state.dashboards.malawiTrainersActivity;
      }
    },
    namibiaActivityData: {
      get() {
        return this.$store.state.dashboards.namibiaTrainersActivity;
      }
    },
    visitData: {
      get() {
        return this.$store.state.mio.visitCount;
      }
    },
    activityStyles() {
      return {
        width: `${this.window.width / 3}px`,
        position: "relative"
      };
    },
    countStyles() {
      return {
        width: `${this.window.width / 4}px`,
        position: "relative"
      };
    }
  },
  created() {
    this.getCountData();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  watched: {},
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.text-boxes {
  display: inline-flex;
  width: 50%;
}
</style>
